module.exports = __webpack_public_path__ + "static/media/personImgVec4x.2398573c.png";